import {
  AdjustmentsHorizontalIcon,
  ArrowsRightLeftIcon,
  BanknotesIcon,
  BellAlertIcon,
  CheckBadgeIcon,
  CircleStackIcon,
  ClipboardDocumentListIcon,
  Cog6ToothIcon,
  CreditCardIcon,
  CurrencyDollarIcon,
  HomeIcon,
  MapPinIcon,
  MegaphoneIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";

export const navigationSections = [
  {
    label: "الرئيسية",
    description: "تحليلات عامة للحسابات والسيولة والعمليات.",
    items: [
      {
        label: "لوحة التحكم",
        path: "/",
        icon: HomeIcon,
        description: "مؤشرات فعلية للحسابات وحركة الأموال وحالات الطلبات.",
      },
    ],
  },
  {
    label: "إدارة العمليات",
    description: "تابع حركة الأموال والطلبات التي تحتاج إلى إجراء.",
    items: [
      {
        label: "إدارة الأموال",
        path: "/balance",
        icon: CurrencyDollarIcon,
        description: "مراجعة أرصدة النظام وحسابات المستخدمين.",
      },
      {
        label: "طلبات التحويل",
        path: "/item_reports",
        icon: ArrowsRightLeftIcon,
        description: "مراجعة الطلبات وتحديث حالاتها.",
      },
      {
        label: "طلبات إضافة الرصيد",
        path: "/cash_requests",
        icon: ClipboardDocumentListIcon,
        description: "اعتماد طلبات إضافة الرصيد ومراجعة الإثباتات.",
      },
      {
        label: "طلبات التوثيق",
        path: "/admin_verification",
        icon: CheckBadgeIcon,
        description: "التحقق من هوية العميل والوثائق المرفقة.",
      },
    ],
  },
  {
    label: "المستخدمين والتواصل",
    description: "أدر تجربة العميل والمحتوى الظاهر داخل تطبيق واصل.",
    items: [
      {
        label: "المستخدمين",
        path: "/customers",
        icon: UsersIcon,
        description: "عرض الحسابات والبيانات وإرسال إشعارات مخصصة.",
      },
      {
        label: "الإشعارات",
        path: "/notification",
        icon: BellAlertIcon,
        description: "إنشاء تنبيهات شخصية أو عامة للعملاء.",
      },
      {
        label: "الإعلانات",
        path: "/add_advertisement",
        icon: MegaphoneIcon,
        description: "تحديث بطاقات وعروض الصفحة الرئيسية للتطبيق.",
      },
    ],
  },
  {
    label: "إعدادات النظام",
    description: "تحكم بالخدمات والأسواق والرسوم من مكان واحد.",
    items: [
      {
        label: "الدول والمحافظات",
        path: "/regions",
        icon: MapPinIcon,
        description: "تحديد المناطق الجغرافية المتاحة للخدمة.",
      },
      {
        label: "العملات",
        path: "/CurrenciesForm",
        icon: BanknotesIcon,
        description: "إدارة العملات المدعومة وأسعارها.",
      },
      {
        label: "طرق الدفع",
        path: "/PaymentMethodForm",
        icon: CreditCardIcon,
        description: "إضافة وتحديث قنوات الدفع المتاحة.",
      },
      {
        label: "طرق التسوية",
        path: "/external_transfer",
        icon: CircleStackIcon,
        description: "إدارة مزودي التسوية وحقولهم.",
      },
      {
        label: "العمولات العامة",
        path: "/transfer_fees",
        icon: Cog6ToothIcon,
        description: "ضبط رسوم الطلبات وإضافة الرصيد العامة.",
      },
      {
        label: "تحديث التطبيق",
        path: "/app_updates",
        icon: AdjustmentsHorizontalIcon,
        description: "إدارة إصدارات التطبيق وروابط المتاجر وتنبيه التحديث.",
      },
    ],
  },
];

export const navigationItems = navigationSections.flatMap(
  (section) => section.items,
);

export const getNavigationItem = (path) =>
  navigationItems.find((item) => item.path === path);
